<template>
  <div class="mall-prescription-files">
    <div
      v-for="file in files"
      :key="file.id"
      class="mall-prescription-files__item"
      :class="{ 'mall-prescription-files__item--pdf': file.isPdf }"
    >
      <template v-if="file.isPdf">
        <div class="mall-prescription-files__pdf">
          <img src="@/assets/mall/icn_pdf_file_color.svg" alt="" />
          <span>PDF</span>
        </div>
      </template>
      <template v-else>
        <img class="mall-prescription-files__image" :src="file.previewUrl" :alt="file.name" />
        <div class="mall-prescription-files__gradient"></div>
      </template>
      <div class="mall-prescription-files__remove" @click="$emit('remove', file.id)">
        <img src="@/assets/mall/icn_close_circle_color.svg" alt="삭제" />
      </div>
    </div>
  </div>
</template>

<script>
// 업로드한 처방전 미리보기 (이미지 / PDF)
export default {
  name: 'MallPrescriptionFiles',
  props: {
    // [{ id, name, isPdf, previewUrl }]
    files: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-prescription-files {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.mall-prescription-files__item {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
}

.mall-prescription-files__item--pdf {
  background: #FFD4D6;
}

.mall-prescription-files__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mall-prescription-files__gradient {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 1px solid #D1D6DB;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(24, 24, 28, 0) 50%, rgba(24, 24, 28, 0.32) 100%);
}

.mall-prescription-files__pdf {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: #F04452;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-prescription-files__pdf img {
  display: block;
}

/* 아이콘(16px) 위치는 Figma 기준 (56, 8), 누르는 영역만 4px 넓힘 */
.mall-prescription-files__remove {
  position: absolute;
  top: 4px;
  left: 52px;
  display: flex;
  padding: 4px;
  cursor: pointer;
}

.mall-prescription-files__remove img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallPrescriptionFiles.vue